import toast from "react-hot-toast";

export const orderSuccessToast = (message: string) => {
    toast.success(message, {
        duration: 3000,
        position: "top-center",
        style: {
            padding: "8px 16px",
            background: "#808080",
            borderRadius: "100px",
            color: "#FFFFFF",
            fontWeight: "bold",
            fontSize: "14px",
            lineHeight: "20px",
        },
    });
};

export const orderErrorToast = (message: string) => {
    toast.error(message, {
        duration: 3000,
        position: "top-center",
        style: {
            padding: "8px 16px",
            background: "#808080",
            borderRadius: "100px",
            color: "#FFFFFF",
            fontWeight: "bold",
            fontSize: "14px",
            lineHeight: "20px",
        },
    });
};